import { } from "jquery"
import { } from "bootstrap"
import { AssetCategory } from "../api/model"
import { AssetCategoryApi, AssetAreaApi, AssetApi, RestfulError } from "../api/api"
import { UiUtils, JqElm, GeneralElementCreator } from "./ui"
import { AssetPageBase, AssetBasicDataProvider } from "./asset_page_base"

export class AssetItemPageBase extends AssetPageBase {

    protected toggleEditButtons(id: string, toggleBtnClasses: Array<string>, nameElm: JqElm) {
        toggleBtnClasses.forEach(className => {
            this.elmById(id, className).toggle()
        })
        nameElm.toggle()
    }

    protected appendItemElm(no: number, id: number, name: string, creator: GeneralElementCreator): JqElm {
        const templateData = {
            no: no,
            id: id,
            name: name
        }
        const elm = creator.createJqElm(templateData)
        elm.appendTo($(creator.tmplElmId).parent())
        return elm
    }

    protected validateAndShowError(elm: JqElm): boolean {
        const valid = (<HTMLInputElement>elm[0]).checkValidity()
        if (!valid) {
            UiUtils.showValidationError(elm, elm.siblings)
        } else {
            UiUtils.hideValidationError(elm, elm.siblings)
        }
        return valid
    }

    updateBackPageLink() {
        $('#backpage').prop('href', 'assetCreate.aspx')
    }
}
/**
 * Main class to handle "**CreateAssetPage**" page UI elements, events, and actions
 */
export class AssetCategoryPage extends AssetItemPageBase {

    //rootContainerId: string = "asset_category_container"

    categoryItemCreator = new CategoryItemElementCreator()
    subCategoryItemCreator = new SubCategoryItemElementCreator()

    constructor(
        assetApi: AssetApi,
        private assetCategoryApi: AssetCategoryApi,
        assetBasicDataProvider: AssetBasicDataProvider
    ) {
        super(assetApi, assetBasicDataProvider)
    }

    private toggleCatEditButtons(id: string) {
        this.toggleEditButtons(id, ['cat_cancel_btn', 'cat_edit_btn', 'cat_save_btn', 'cat_delete_btn', 'cat_name'], this.elmById(id, null, 'name'))
    }

    private toggleSubCatEditButtons(id: string) {
        this.toggleEditButtons(id, ['sub_cat_cancel_btn', 'sub_cat_edit_btn', 'sub_cat_save_btn', 'sub_cat_delete_btn', 'sub_cat_name'], this.elmById(id, null, 'sub_cat_name'))
    }

    listenCatAddClick() {
        const validateAndCreate = async (valElm: JqElm, parentId: number) => {
            const name = <string>valElm.val()
            const valid = this.validateAndShowError(valElm) && this.validateCatNameConflict(name, parentId)
            if (valid) {
                valElm.val('')
                await this.createCategory(name, parentId)
                await this.refreshCategoryElms()
                return true
            } else {
                return false
            }
        }
        $('#add_sub_cat_btn').click(e => {
            const valElm = $('#add_sub_cat_name')
            const parentId = Number($('#cat_select').val())
            validateAndCreate(valElm, parentId).then(rt => {
                if (rt) {
                    $('#cat_select').val(parentId).change()
                }
            })
        })
        $('#add_cat_btn').click(e => {
            const valElm = $('#add_cat_name')
            const parentId = 0
            validateAndCreate(valElm, parentId)
        })
    }

    listenCatSelectChange() {
        $('#cat_select').change(e => {
            const elm = $(e.currentTarget)
            const val = Number(elm.val())
            const disabled = val == 0
            const addNameElm = $('#add_sub_cat_name')
            UiUtils.hideValidationError(addNameElm, addNameElm.siblings)
            console.log("Value:%s - disabled:%s", val, disabled)
            UiUtils.setDisabled($('#add_sub_cat_btn'), disabled)
            UiUtils.setDisabled(addNameElm, disabled)
            this.refreshSubCatItemElms(val)
        })
    }

    listenCatEditClicks() {
        const validateAndUpdate = async (id: number, valElm: JqElm, displayElm: JqElm, parentId: number) => {
            const name = <string>valElm.val()
            const valid = this.validateAndShowError(valElm) && this.validateCatNameConflict(name, parentId, id)
            if (valid) {
                this.toggleSubCatEditButtons(id.toString())
                displayElm.text(name)
                await this.updateCategory(id, name)
                await this.refreshCategoryElms()
                return true
            } else {
                return false
            }
        }

        $(document)
            .on('click', '.cat_edit_btn', e => {
                e.preventDefault()
                console.log("Edit click")
                const btnElm = $(e.currentTarget)
                const id = btnElm.data('id')
                this.toggleCatEditButtons(id)
            })
            .on('click', '.cat_cancel_btn', e => {
                e.preventDefault()
                const btnElm = $(e.currentTarget)
                const id = btnElm.data('id')
                const editElm = this.elmById(id, null, 'name')
                UiUtils.hideValidationError(editElm, editElm.next)
                const displayElm = this.elmById(id, 'cat_name')
                editElm.val(displayElm.text())
                this.toggleCatEditButtons(id)
            })
            .on('click', '.cat_save_btn', e => {
                e.preventDefault()
                const btnElm = $(e.currentTarget)
                const id = Number(btnElm.data('id'))
                const editElm = this.elmById(id, null, 'name')
                const displayElm = this.elmById(id, 'cat_name')
                const parentId = 0
                validateAndUpdate(id, editElm, displayElm, parentId)
            })
            .on('click', '.cat_delete_btn', e => {
                e.preventDefault()
                const btnElm = $(e.currentTarget)
                const id = Number(btnElm.data('id'))
                this.confirmAndDeleteCategory(id)
            })
            .on('click', '.sub_cat_edit_btn', e => {
                e.preventDefault()
                console.log("Edit click")
                const btnElm = $(e.currentTarget)
                const id = btnElm.data('id')
                this.toggleSubCatEditButtons(id)
            })
            .on('click', '.sub_cat_cancel_btn', e => {
                e.preventDefault()
                const btnElm = $(e.currentTarget)
                const id = btnElm.data('id')
                const editElm = this.elmById(id, null, 'sub_cat_name')
                UiUtils.hideValidationError(editElm, editElm.next)
                const displayElm = this.elmById(id, 'sub_cat_name')
                editElm.val(displayElm.text())
                this.toggleSubCatEditButtons(id)
            })
            .on('click', '.sub_cat_save_btn', e => {
                e.preventDefault()
                const btnElm = $(e.currentTarget)
                const id = Number(btnElm.data('id'))
                const editElm = this.elmById(id, null, 'sub_cat_name')
                const displayElm = this.elmById(id, 'sub_cat_name')
                const parentId = this.assetBasicDataProvider.catMap[id].parentId
                validateAndUpdate(id, editElm, displayElm, parentId).then(rt => {
                    if (rt) {
                        $('#cat_select').val(parentId).change()
                    }
                })
            })
            .on('click', '.sub_cat_delete_btn', e => {
                e.preventDefault()
                const btnElm = $(e.currentTarget)
                const id = Number(btnElm.data('id'))
                const parentId = this.assetBasicDataProvider.catMap[id].parentId

                this.confirmAndDeleteCategory(id).then((deleted) => {
                    if (deleted) {
                        $('#cat_select').val(parentId).change()
                    }
                })
            })
    }

    refreshCategoryElms() {
        this.refreshCatItemElms()
        this.refreshCatSelectElm()
    }

    private validateCatNameConflict(name: string, parentId: number, id?: number): boolean {
        let catsToCheck = this.assetBasicDataProvider.catParentMap.get(parentId)
        if (catsToCheck.find(it => {
            console.log("%s - %s - %s - %s", it.name, name, it.id, id)
            return it.name == name && it.id != id
        }) == null) {
            return true
        } else {
            UiUtils.alert("分類名稱重複")
            return false
        }
    }

    private async createCategory(name: string, parentId: number): Promise<void> {
        try {
            await this.assetCategoryApi.create({ name: name, parentId: parentId })
            await this.assetBasicDataProvider.initCategories()
        } catch (e) {
            UiUtils.alertIfClientError(e)
        }
    }

    private async updateCategory(id: number, name: string): Promise<void> {
        try {
            await this.assetCategoryApi.update(id, { name: name })
            await this.assetBasicDataProvider.initCategories()
        } catch (e) {
            UiUtils.alertIfClientError(e)
        }
    }

    private refreshCatSelectElm() {
        const elm = $('#cat_select')
        UiUtils.cleanOptions(elm)
        elm.append(UiUtils.options("請選擇分類", ""))
        this.assetBasicDataProvider.catRoots.forEach(cat => {
            elm.append(UiUtils.options(cat.name, cat.id.toString()))
        })
        elm.change()
    }

    private refreshSubCatItemElms(rootCatId: number) {
        $(`.${this.subCategoryItemCreator.classId}`).remove()
        if (rootCatId == 0) {
            return
        }
        let no = 1
        this.assetBasicDataProvider.catParentMap.get(rootCatId).filter(it => !it.isDefaultSubCat).forEach(cat => {
            this.appendSubCatItemElm(no++, cat.id, cat.name)
        })
    }

    private refreshCatItemElms() {
        $(`.${this.categoryItemCreator.classId}`).remove()
        let no = 1
        this.assetBasicDataProvider.catRoots.forEach(cat => {
            this.appendCatItemElm(no++, cat.id, cat.name)
        })
    }

    private appendCatItemElm(no: number, id: number, name: string): JqElm {
        return this.appendItemElm(no, id, name, this.categoryItemCreator)
    }

    private appendSubCatItemElm(no: number, id: number, name: string): JqElm {
        return this.appendItemElm(no, id, name, this.subCategoryItemCreator)
    }

    private async confirmToDelete(categoryId: number): Promise<boolean> {
        const cat = this.assetBasicDataProvider.catMap[categoryId]
        const message = (await this.hasExistingAsset(cat)) ? `「${cat.name}」目前有登記資產項目，如果刪除分類，已登記的資產將變成待分類，請問確定要刪除嗎？` : `請問要刪除「${cat.name}」分類嗎？`
        return UiUtils.confirm(message)
    }

    private async confirmAndDeleteCategory(categoryId: number): Promise<boolean> {
        const toDelete = await this.confirmToDelete(categoryId)
        if (toDelete) {
            await this.deleteCategory(categoryId)
            this.refreshCategoryElms()
        }
        return toDelete
    }

    private async deleteCategory(categoryId: number): Promise<void> {
        try {
            await this.assetCategoryApi.delete(categoryId)
            await this.assetBasicDataProvider.initCategories()
        } catch (e) {
            UiUtils.alertIfClientError(e)
        }
    }

    private async hasExistingAsset(category: AssetCategory): Promise<boolean> {
        let cats = null
        console.log("hasExistingAsset - id:%s parent:%s", category.id, category.parentId)
        if (category.parentId != 0) {
            cats = [category.id]
        } else {
            cats = this.assetBasicDataProvider.catParentMap.get(category.id).map(it => it.id)
        }
        return (await this.assetApi.query({ maxCount: 1, offset: 0, categoryIds: cats })).total > 0
    }

}

export class AssetAreaPage extends AssetItemPageBase {
    areaItemCreator = new AreaItemElementCreator()

    constructor(
        assetApi: AssetApi,
        private assetAreaApi: AssetAreaApi,
        assetBasicDataProvider: AssetBasicDataProvider
    ) {
        super(assetApi, assetBasicDataProvider)

    }

    listenAreaAddClick() {
        $('#add_area_btn').click(e => {
            const valElm = $('#add_area_name')
            const name = <string>valElm.val()
            const valid = this.validateAndShowError(valElm) && this.validateAreaNameConflict(name)
            if (valid) {
                valElm.val('')
                this.createArea(name).then(() => {
                    this.refreshAreaItemElms()
                })
            }
        })
    }

    private validateAreaNameConflict(name: string, id?: number): boolean {
        if (this.assetBasicDataProvider.areas.find(it => {
            console.log("%s - %s - %s - %s", it.name, name, it.id, id)
            return it.name == name && it.id != id
        }) == null) {
            return true
        } else {
            UiUtils.alert("區域名稱重複")
            return false
        }
    }

    private async hasExistingAsset(areaId: number): Promise<boolean> {
        return (await this.assetApi.query({ offset: 0, maxCount: 1, areaId: areaId })).total > 0
    }

    private async confirmAndDelete(areaId: number): Promise<boolean> {
        const toDelete = await this.confirmToDelete(areaId)
        if (toDelete) {
            await this.deleteArea(areaId)
            this.refreshAreaItemElms()
        }
        return toDelete
    }

    private async confirmToDelete(areaId: number): Promise<boolean> {
        const area = this.assetBasicDataProvider.areaMap[areaId]
        const message = (await this.hasExistingAsset(areaId)) ? `「${area.name}」目前有登記資產項目，如果刪除區域分類，已登記的資產將變成待分區，請問確定要刪除嗎？` : `請問要刪除「${area.name}」區域嗎？`
        return UiUtils.confirm(message)
    }

    private async deleteArea(areaId: number): Promise<void> {
        try {
            await this.assetAreaApi.delete(areaId)
            await this.assetBasicDataProvider.initAreas()
        } catch (e) {
            UiUtils.alertIfClientError(e)
        }
    }

    private async createArea(name: string): Promise<void> {
        try {
            await this.assetAreaApi.create({ name: name })
            await this.assetBasicDataProvider.initAreas()
        } catch (e) {
            UiUtils.alertIfClientError(e)
        }
    }

    private async updateArea(id: number, name: string): Promise<void> {
        try {
            await this.assetAreaApi.update(id, { name: name })
            await this.assetBasicDataProvider.initAreas()
        } catch (e) {
            UiUtils.alertIfClientError(e)
        }
    }

    listenAreaEditClicks() {
        $(document).on('click', '.area_edit_btn', e => {
            e.preventDefault()
            console.log("Edit click")
            const btnElm = $(e.currentTarget)
            const id = btnElm.data('id')
            this.toggleAreaEditButtons(id)
        })

        $(document).on('click', '.area_cancel_btn', e => {
            e.preventDefault()
            const btnElm = $(e.currentTarget)
            const id = btnElm.data('id')
            const editElm = this.elmById(id, null, 'area_name')
            UiUtils.hideValidationError(editElm, editElm.next)
            const displayElm = this.elmById(id, 'area_name')
            editElm.val(displayElm.text())
            this.toggleAreaEditButtons(id)
        })

        const validateAndUpdate = async (id: number, valElm: JqElm, displayElm: JqElm) => {
            const name = <string>valElm.val()
            const valid = this.validateAndShowError(valElm) && this.validateAreaNameConflict(name, id)
            if (valid) {
                this.toggleAreaEditButtons(id.toString())
                displayElm.text(name)
                await this.updateArea(id, name)
                await this.refreshAreaItemElms()
                return true
            } else {
                return false
            }
        }

        $(document).on('click', '.area_save_btn', e => {
            e.preventDefault()
            const btnElm = $(e.currentTarget)
            const idStr = btnElm.data('id')
            const id = Number(idStr)
            const editElm = this.elmById(id, null, 'area_name')
            const displayElm = this.elmById(id, 'area_name')
            validateAndUpdate(id, editElm, displayElm)
        })

        $(document).on('click', '.area_delete_btn', e => {
            e.preventDefault()
            const btnElm = $(e.currentTarget)
            const id = btnElm.data('id')
            console.log("Delete item:%s", id)
            this.confirmAndDelete(id)
        })

    }

    refreshAreaItemElms() {
        $(`.${this.areaItemCreator.classId}`).remove()
        let no = 1
        this.assetBasicDataProvider.areas.forEach(area => {
            this.appendAreaItemElm(no++, area.id, area.name)
        })
    }

    private toggleAreaEditButtons(id: string) {
        this.toggleEditButtons(id, ['area_cancel_btn', 'area_edit_btn', 'area_save_btn', 'area_delete_btn', 'area_name'], this.elmById(id, null, 'area_name'))
    }

    private appendAreaItemElm(no: number, id: number, name: string): JqElm {
        return this.appendItemElm(no, id, name, this.areaItemCreator)
    }
}


export class CategoryItemElementCreator extends GeneralElementCreator {
    classId: string = 'category_item'
}

export class SubCategoryItemElementCreator extends GeneralElementCreator {
    classId: string = 'sub_category_item'
}

export class AreaItemElementCreator extends GeneralElementCreator {
    classId: string = 'area_item'
}
